import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { getAuthToken } from '@/shared/api/getAuthToken';

import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

type CreateAccountParams = {
  email?: string;
  referral?: string;
};

const createAccount = async ({ email, referral }: CreateAccountParams) => {
  const token = await getAuthToken();

  return API.createAccount({ email, referral_id: referral || '', token });
};

export const useCreateAccount = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAccount,
    onSuccess: (user) => {
      queryClient.setQueryData(USER_QUERY_KEYS.account, user);
    },
  });
};
